// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"2b0c1a1a44431cc1","5285":"23507de5850696fd"}[chunkId] + ".css";
};